import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import des traductions
import enTranslation from './locales/en/translation.json';
import frTranslation from './locales/fr/translation.json';

const resources = {
  en: {
    translation: enTranslation
  },
  fr: {
    translation: frTranslation
  }
};

i18n
  // Détection automatique de la langue
  .use(LanguageDetector)
  // Passe l'instance i18n à react-i18next
  .use(initReactI18next)
  // Initialise i18next
  .init({
    resources,
    
    // Langue de fallback si la détection échoue
    fallbackLng: 'en',
    
    // Langues supportées
    supportedLngs: ['en', 'fr'],
    
    // Options de détection de langue
    detection: {
      // Ordre de détection : localStorage, navigator, htmlTag, path, subdomain
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      
      // Cache la langue détectée dans localStorage
      caches: ['localStorage'],
      
      // Clé pour le localStorage
      lookupLocalStorage: 'i18nextLng',
      
      // Ne pas détecter à partir des cookies pour des raisons de confidentialité
      excludeCacheFor: ['cimode'],
      
      // Vérifier seulement les langues supportées
      checkWhitelist: true
    },

    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false // React échappe déjà les valeurs
    },

    // Options de formatage
    returnEmptyString: false,
    
    // Callback appelé quand la langue change
    react: {
      useSuspense: false
    }
  });

// Fonction pour changer la langue et mettre à jour l'attribut lang du HTML
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

// Définir la langue initiale sur l'élément HTML
document.documentElement.lang = i18n.language;

export default i18n;